/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IIndexedNode } from '../../../core/models/IIndexedNode';
import { Node } from '../../../core/models/Node';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';

/**
 * Constructor.
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export class Oas20Definitions extends Node implements IIndexedNode<Oas20SchemaDefinition> {
    public items : any;

    public constructor() {
        super();
        this.items = <any>({});
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitDefinitions(this);
    }

    /**
     * Returns a single definition schema by name.
     * @param {string} name
     * @return {Oas20SchemaDefinition}
     */
    public getDefinition(name : string) : Oas20SchemaDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, name);
    }

    /**
     * Returns an array of all the definitions.
     * @return {Oas20SchemaDefinition[]}
     */
    public getDefinitions() : Array<Oas20SchemaDefinition> {
        let rval : Array<Oas20SchemaDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.items));
        return rval;
    }

    /**
     * Adds a definition.
     * @param {string} name
     * @param {Oas20SchemaDefinition} schema
     * @return {Oas20SchemaDefinition}
     */
    public addDefinition(name : string, schema : Oas20SchemaDefinition) : Oas20SchemaDefinition {
        /* put */(this.items[name] = schema);
        return schema;
    }

    /**
     * Removes a definition by name.
     * @param {string} name
     * @return {Oas20SchemaDefinition}
     */
    public removeDefinition(name : string) : Oas20SchemaDefinition {
        return /* remove */(map => { let deleted = this.items[name];delete this.items[name];return deleted;})(this.items);
    }

    /**
     * Gets a list of all the definition names.
     * @return {string[]}
     */
    public getDefinitionNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        return rval;
    }

    /**
     * Creates an OAS 2.0 Schema object.
     * @param {string} name
     * @return {Oas20SchemaDefinition}
     */
    public createSchemaDefinition(name : string) : Oas20SchemaDefinition {
        let rval : Oas20SchemaDefinition = new Oas20SchemaDefinition(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {Oas20SchemaDefinition}
     */
    public getItem(name : string) : Oas20SchemaDefinition {
        return this.getDefinition(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {Oas20SchemaDefinition[]}
     */
    public getItems() : Array<Oas20SchemaDefinition> {
        return this.getDefinitions();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getDefinitionNames();
    }

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20SchemaDefinition(name : string, item : Oas20SchemaDefinition) {
        this.addDefinition(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {Oas20SchemaDefinition} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>Oas20SchemaDefinition) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20SchemaDefinition(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {Oas20SchemaDefinition}
     */
    public deleteItem(name : string) : Oas20SchemaDefinition {
        return this.removeDefinition(name);
    }
}
Oas20Definitions["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Definitions";
Oas20Definitions["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas20SchemaDefinition } from './Oas20SchemaDefinition';

